import { z } from 'zod';

export const walletHistoryItemSchema = z.object({
  transactionDate: z.string(),
  amount: z.number(),
  message: z.string(),
});

export const walletSummaryDataSchema = z.object({
  hasSavingWallet: z.boolean(),
  totalPoints: z.number(),
  history: z.array(walletHistoryItemSchema),
});

export const walletSummaryResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  status: z.string(),
  data: walletSummaryDataSchema,
});

export type WalletHistoryItem = z.infer<typeof walletHistoryItemSchema>;
export type WalletSummaryData = z.infer<typeof walletSummaryDataSchema>;
export type WalletSummaryResponse = z.infer<typeof walletSummaryResponseSchema>;